import React, { ReactNode } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import {
  GetMaximumBenefit_payment_event_list_for_display_item_list as PaymentEventList,
  PaymentNotificationItemList,
} from '@domains/pdp-common';

import { EventNotificationList } from './EventNotificationList';
import { PaymentBenefitCard } from './PaymentBenefitCard';
import { PaymentBenefitCardList } from './PaymentBenefitCardList';
import { PaymentBenefitCardNameList } from './PaymentBenefitCardNameList';

interface BenefitProps {
  paymentEventList: PaymentEventList[];
  paymentEventNotificationList: PaymentNotificationItemList[];
  higherDiscountAmount: number;
  eventNameList: string[];
  isOverExposureEventLimit: boolean;
  openInterestFeeSheet: (children: ReactNode) => void;
  openPaymentBottomSheet: (item?: PaymentEventList | PaymentNotificationItemList) => void;
}

export const PaymentBenefit: React.FC<React.PropsWithChildren<BenefitProps>> = ({
  paymentEventList,
  paymentEventNotificationList,
  higherDiscountAmount,
  eventNameList,
  isOverExposureEventLimit,
  openInterestFeeSheet,
  openPaymentBottomSheet,
}) => {
  const displayBenefit =
    paymentEventNotificationList.length > 0 ||
    paymentEventList.some(({ payment_event_detail_list }) => payment_event_detail_list.length > 0);

  return (
    <PdpBenefit>
      <BenefitRow>
        <Title className={Typography.BODY_14_MEDIUM}>결제 혜택</Title>
        <div>
          {displayBenefit && (
            <BenefitData>
              {isOverExposureEventLimit ? (
                <WrapBenefit onClick={() => openPaymentBottomSheet()}>
                  <PaymentBenefitCard cardName='행사카드 결제 시' discount_amount={higherDiscountAmount} />
                  <PaymentBenefitCardNameList eventNameList={eventNameList} />
                </WrapBenefit>
              ) : (
                <>
                  {paymentEventNotificationList.length > 0 && (
                    <EventNotificationList list={paymentEventNotificationList} onClick={openPaymentBottomSheet} />
                  )}
                  {paymentEventList?.length > 0 && (
                    <PaymentBenefitCardList language={'ko'} list={paymentEventList} onClick={openPaymentBottomSheet} />
                  )}
                </>
              )}
            </BenefitData>
          )}
          <GetToInterestFreeTable className={Typography.BODY_14_MEDIUM} onClick={() => openInterestFeeSheet(undefined)}>
            무이자 혜택보기
          </GetToInterestFreeTable>
        </div>
      </BenefitRow>
    </PdpBenefit>
  );
};

const PdpBenefit = styled.div`
  margin: 0 16px;
  padding: 16px 0;
`;

const BenefitRow = styled.div`
  display: flex;
  align-items: flex-start;

  p {
    min-width: 56px;
    margin-right: 8px;
    line-height: 18px;
  }
`;

const Title = styled.p`
  color: ${vars.color.textTertiary};
`;

const BenefitData = styled.div`
  margin: 0 0 9px 0;
`;

const WrapBenefit = styled.div`
  padding: 2px 0;
  position: relative;
  top: -2px;
`;

const GetToInterestFreeTable = styled.div`
  display: flex;
  align-items: center;
  color: ${vars.color.textTertiary};
  text-decoration: underline;
  cursor: pointer;
`;
